"use client"

import { analyticsEvent, analyticsEventData, useAppContext } from "@/lib/context/app-context"
import { useEffect } from "react"

type Input = {
    event: analyticsEvent
    data: analyticsEventData
}

export const Track = ({
    event,
    data
}: Input) => {
    let appContext = useAppContext()
    useEffect(() => {
        appContext.analytics?.(event, data);
    }, [])
    return <></>
}